module.exports = __webpack_public_path__ + "static/img/3cbbf196-e7c7-421d-a8fe-06ff83993823.edbc083.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/3cbbf196-e7c7-421d-a8fe-06ff83993823.png
// module id = UxU8
// module chunks = 1